﻿import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { ReactComponent as BackSvg } from "@/assets/images/desktop/volver.svg";

import classes from "./purchaseFilter.module.scss";

const ButtonFilter = ({ origin, size_md, showFilter, setShowFilter, show_back }) => {
	const navigate = useNavigate();

	return (
		<Col md={size_md} className={origin === "actions" ? classes.filter_col : classes.filter_col_main}>
			{show_back && <BackSvg className={classes.button_back} onClick={() => navigate(-1)} />}

			<div
				className={`${origin === "actions" ? classes.filterButton : classes.filterButtonMain} ${showFilter && classes.active}`}
				onClick={() => setShowFilter(!showFilter)}
			>
				<span>Filtros</span>
			</div>
		</Col>
	);
};

export default ButtonFilter;
